export const TribeAccountAddresses = () => {
  const $tribeAccount = document.querySelector(".tribe-account-addresses");

  //header height used for scrolling elements into view
  const header = document.querySelector(".header");
  let headerHeight = 50;
  if (header) {
    headerHeight = header.getBoundingClientRect().height;
  }

  if ($tribeAccount) {
    const $wrapper = $tribeAccount.querySelector(
      ".tribe-account-addresses__wrapper"
    );

    if ($wrapper) {
      const $backOverView = $wrapper.querySelector(
        ".tribe-account-addresses__back"
      );
      const $backProfile = $wrapper.querySelector(
        ".tribe-account-addresses__back.tribe-account-addresses__back--profile"
      );
      const $wrapperGrid = $wrapper.querySelector(".wrapper__grid");

      if ($backOverView && $backProfile && $wrapperGrid) {
        const $gridContents = $wrapper.querySelector(".grid__contents");
        const $gridLinks = $wrapperGrid.querySelector(".grid__links");
        if ($gridLinks && $gridContents) {
          const $gridLinkAddresses = $gridLinks.querySelector(
            ".grid__link.grid__link--addresses"
          );
          const $headerNew = $tribeAccount.querySelector(".header__new");
          const $addressesListItems = $wrapper.querySelectorAll(
            ".addresses__list-item"
          );
          const $addressesForms = $wrapper.querySelectorAll(
            ".addresses__forms .addresses__form"
          );
          const $cancelButtons = $wrapper.querySelectorAll(".button__cancel");

          if (
            $gridLinkAddresses &&
            $headerNew &&
            $addressesForms &&
            $addressesListItems &&
            $cancelButtons
          ) {
            //Add new Address form
            $headerNew.addEventListener("click", (event) => {
              event.preventDefault();
              $addressesForms.forEach(($addressesForm) => {
                if ($addressesForm.dataset.id == $headerNew.dataset.id) {
                  $addressesForm.classList.add("addresses__form--active");
                } else {
                  $addressesForm.classList.remove("addresses__form--active");
                }
                if (window.innerWidth < 1024) {
                  $addressesForms[0].scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              });
            });

            //Open a form via an Edit button
            $addressesListItems.forEach(($addressesListItem) => {
              const $edit = $addressesListItem.querySelector(".button__edit");
              $edit.addEventListener("click", (event) => {
                event.preventDefault();
                $addressesForms.forEach(($addressesForm) => {
                  if (
                    $addressesForm.dataset.id == $addressesListItem.dataset.id
                  ) {
                    $addressesForm.classList.add("addresses__form--active");

                    if (window.innerWidth < 1024) {
                      $addressesForm.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  } else {
                    $addressesForm.classList.remove("addresses__form--active");
                  }
                });
              });
            });

            //Cancel a form - just hide it
            $cancelButtons.forEach(($cancelButton) => {
              $cancelButton.addEventListener("click", () => {
                //Find the parent container for this form and hide it
                const $parent = $cancelButton.closest(".addresses__form");
                if ($parent) {
                  $parent.classList.remove("addresses__form--active");
                }

                //If viewing on a phone, scroll user back up the page
                if (window.innerWidth < 1024) {
                  if ($parent.dataset.id) {
                    if ($parent.dataset.id == "new") {
                      //scroll back to the "Add new" button
                      window.scrollTo({
                        top:
                          $headerNew.getBoundingClientRect().top +
                          window.scrollY -
                          headerHeight -
                          20,
                        behavior: "smooth",
                      });
                    } else {
                      $addressesListItems.forEach(($addressesListItem) => {
                        if (
                          $addressesListItem.dataset.id === $parent.dataset.id
                        ) {
                          if (window.innerWidth < 1024) {
                            $addressesListItem.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            });
                          }
                        }
                      });
                    }
                  }
                }
              });
            });

            /*
                            Clicking on "Back to my profile" on a phone will hide the main view and show the tabs
                            But expanding to desktop would make them all visible
                        */

            $backProfile.addEventListener("click", () => {
              //Hide "Back to Profile" button
              $backProfile.classList.remove("flex");
              $backProfile.classList.add("hidden");

              //Show back to Overview button
              $backOverView.classList.add("flex");
              $backOverView.classList.remove("hidden");

              //hide forms
              $gridContents.classList.add("hidden");
              $gridContents.classList.remove("flex");

              //show grid links
              $gridLinks.classList.add("flex");
              $gridLinks.classList.remove("hidden");
            });

            //pointer-events-none prevents this firing on desktop - revert the above changes and make the forms section visible again
            $gridLinkAddresses.addEventListener("click", () => {
              //Unhide "Back to Profile" button
              $backProfile.classList.add("flex");
              $backProfile.classList.remove("hidden");

              //Hide back to Overview button
              $backOverView.classList.remove("flex");
              $backOverView.classList.add("hidden");

              //Show forms
              $gridContents.classList.remove("hidden");
              $gridContents.classList.add("flex");

              //Hide grid links
              $gridLinks.classList.remove("flex");
              $gridLinks.classList.add("hidden");
            });
          }
        }
      }
    }
  }
};

export default TribeAccountAddresses;
